// extracted by mini-css-extract-plugin
export default {"container":"CredentialsModal_container__iqICB"};